import React from 'react'
import { localisationMaster } from 'Localisation/Localisation'
import SelectCustom from '../../Global/Select/SelectCustom'
import './GroupFilter.scss'
import TypeSelector from '../../Global/GlobalModalSingle/templates/WorkPlain/TypeSelector'

export default function GroupFilter({
  data,
  onChange,
  drop,
  setFilter,
  onlineStatus,
}) {
  let dataStorage = localStorage.getItem('ud')
  let dataLS = JSON.parse(dataStorage)
  let companyID = dataLS.user_data.profile.company.id
  const changeHandler = (value, key) => {
    onChange(value, key)
  }

  const multiple = (d) => {
    let a = d.map((x) => x.id)
    onChange(a, 'location')
  }

  return (
    <div className='group-filter'>
      <div className='group-filter__selectors'>
        <div className='group-filter__selectorUnit'>
          <p> {localisationMaster('text_30', 'groups/all-groups')}</p>
          <SelectCustom
            placeholder={'Дисциплина'}
            apiLink='db/disciplines'
            apiGetResult={(value) => value.result.sort((a, b) => a.id - b.id)}
            valueID={data.discipline || 0}
            onChange={(o) => changeHandler(o.id, 'discipline')}
            isSearchable
          />
        </div>
        <div className='group-filter__selectorUnit'>
          <p> {localisationMaster('text_32', 'groups/all-groups')}</p>
          <SelectCustom
            placeholder={'Локация'}
            apiConfParams={{ companies: companyID }}
            apiLink='db/locations'
            valueID={data.location || [0]}
            onChange={(o) => multiple(o)}
            isMulti
          />
        </div>
        <div className='group-filter__selectorUnit'>
          <p>Тип группы</p>
          <TypeSelector
            values={onlineStatus}
            like_obj={true}
            objectChangeHandler={(selectedValue, name) => {
              changeHandler(selectedValue, 'online')
            }}
            selected={data.online}
            name={'online'}
          />
        </div>
      </div>

      <div className='group-filter__line'>
        <div className='filter-box__buttons'>
          <button
            className='filter-box__apply-button'
            onClick={() => setFilter()}
          >
            {localisationMaster('text-7', 'filter')}
          </button>
          <span className='filter-box__reset-button' onClick={drop}>
            {localisationMaster('text-10', 'filter')}
          </span>
        </div>
      </div>
    </div>
  )
}
